import React, { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import { Modal, Button } from 'react-bootstrap';
import cryptoJS from 'crypto-js';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {

  const [show, setShow] = useState(true);
  const [value, setValue] = useState(null);
  const [link, setLink] = useState(null);
  const [otp, setOtp] = useState(null);
  const [message, setMessage] = useState(null);
  const [showResendOTP, setShowResendOTP] = useState(false);
  const [timer, setTimer] = useState("");

  useEffect(() => {
    generate();
  }, [])

  const startTimer = () => {
    let text = "Resend otp in ";
    let secs = 5;
    let timeInterval = setInterval(() => {
      secs = secs - 1;
      setTimer(`${text}${secs} seconds.`)
      if (secs == 0) {
        clearInterval(timeInterval);
        setTimer("");
        setShowResendOTP(true);
      }
    }, 1000)
  }

  const generate = () => {
    setShow(true)
    let url = window.location.href;
    let val = url.split("/").pop();
    setMessage(val)
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', "authorization": "basic REdER0AjMTUmJjQzNTJGRlclXkRGR0RHZWgyMzQjNDU2N0hHNTIzcnRALjU3VmtGd2RUbDEzMTI0b1l6SnhNMVU9PQ==" },
      body: JSON.stringify({ 'message': val })
    };
    fetch('https://kvs.khushaalwatan.com/api/v2/k-zamindar/otp-originator', options)
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setOtp(data?.data?.otp);
          // startTimer()
        }
      })
  }

  const resendOTP = () => {
    generate();
  }

  const decrypt = () => {
    if (otp === value) {
      const secretKey = "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3";
      let msg = message;
      msg = msg.replace(/p1L2u3S/g, "+").replace(/s1L2a3S4h/g, "/").replace(/e1Q2u3A4l/g, "=");
      let code = cryptoJS.AES.decrypt(msg, secretKey);
      let decryptedMessage = code.toString(cryptoJS.enc.Utf8);
      let url = decryptedMessage.substring(decryptedMessage.indexOf("_") + 1);
      setLink(url)
      setShow(false)
    }
    else {
      alert("Wrong OTP!");
    }
  }

  // const validate = () => {
  //   const options = {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ otp: value })
  //   };
  //   fetch('https://kvs.khushaalwatan.com/api/magri_revamp/kz-vs/k-video/otp-originator', options)
  //     .then(response => response.json())
  //     .then(data => {
  //       if (data?.success) {
  //         setLink(data?.url)
  //         setShow(false)
  //       }
  //     })
  // }

  return (
    <div className="App">
      <div>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          backdrop="static"
          data-keyboard="false"
          keyboard={false}
          centered
        >
          <Modal.Header>
            <Modal.Title>Enter OTP</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <OtpInput
              value={value}
              onChange={(otp) => setValue(otp)}
              numInputs={4}
              separator={<span>-</span>}
              inputStyle={{ width: '70%', height: '10vh', fontSize: '5vh', marginRight: '10%' }}
            />
          </Modal.Body>
          <Modal.Footer>
            {
              showResendOTP ? <a href='#' onClick={resendOTP}>
                Resend OTP
              </a> : <p>{timer}</p>
            }

            <Button
              variant="dark"
              onClick={() => decrypt()}
            >Validate
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <p style={{ textAlign: 'center', fontFamily: 'Open Sans', fontSize: '4vw', maxHeight: '50vh' }}>
        KZ - Video Service
      </p>
      <div style={{ textAlign: 'center', marginTop: '5%' }}>
        <iframe src={link} width="100%" height="500" frameBorder="0" allowFullScreen />
      </div>
    </div>
  );
}

export default App;